import NotificationManagementAllComponent from './notification_management.all.component';

let NotificationManagementAllModule = angular.module('notificationManagementAll', [
])

    .component('notificationManagementAll', NotificationManagementAllComponent)
    .name;

export default NotificationManagementAllModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/notification_management/all/index.js